import React, { useEffect, useState } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";
import { api_url } from "../../constant/constant";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const EmailBreachAllUsers = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const fetchData = async (page = 1) => {
    setLoading(true);

    try {
      const token = localStorage.getItem("userToken");

      const response = await fetch(
        `${api_url}/breach-check/all-users/results?per_page=10&page=${page}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      setData(result.data?.data || []);
      setLinks(result.data?.links || []);
      setCurrentPage(result.data?.current_page || Number(page) || 1);
    } catch (error) {
      console.error("Error fetching breach users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(1);
  }, []);

  const handlePageClick = (url) => {
    if (!url) return;

    const parsedUrl = new URL(url);
    const page = parsedUrl.searchParams.get("page") || 1;

    fetchData(page);
  };

  const columns = React.useMemo(
    () => [
      {
        accessorFn: (row) => row.user?.username || "-",
        header: "Username",
      },
      {
        accessorKey: "email",
        header: "Email",
        cell: ({ getValue }) => getValue() || "-",
      },
      {
        accessorKey: "compromised",
        header: "Compromised",
        cell: ({ getValue }) => (getValue() ? "Yes" : "No"),
      },
      {
        accessorKey: "breaches",
        header: "Breaches",
        cell: ({ getValue }) =>
          Array.isArray(getValue()) && getValue().length > 0
            ? getValue().join(", ")
            : "-",
      },
    ],
    []
  );

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  const handleSurveyRowClick = (checkId) => {
    if (!checkId) return;
    navigate(`/AllUsersBreachResultsCheckId/${checkId}`);
  };

  return (
    <div className="container-fluid">
      <h3 className="mb-3">{t("AllUsersBreachResults")}</h3>

      {loading ? (
        <div>Loading...</div>
      ) : (
        <>
          <div className="bg-light px-3 py-3 overflow-auto">
            <table className="table table-bordered table-hover">
              <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => (
                      <th key={header.id}>
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>

              <tbody>
                {table.getRowModel().rows.length > 0 ? (
                  table.getRowModel().rows.map((row) => (
                    <tr
                      key={row.id}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handleSurveyRowClick(row.original.check_id)
                      }
                    >
                      {row.getVisibleCells().map((cell) => (
                        <td key={cell.id}>
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={columns.length} className="text-center">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="navigationWrapper mt-3">
            <ul>
              {links.map((link, index) => (
                <li
                  key={index}
                  className={`${link.active ? " active " : ""} ${
                    link.url === null ? " disabled " : ""
                  }`}
                  onClick={() => handlePageClick(link.url)}
                >
                  <div dangerouslySetInnerHTML={{ __html: link.label }} />
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </div>
  );
};

export default EmailBreachAllUsers;